import { useEffect } from "react";

const useImportIfVisible = (setIfVisible) => {
  useEffect(() => {
    // We create and call an async function within the useEffect to avoid directly passing it an async function.
    // useEffect should always return either nothing or a cleanup function; an async function returns a promise.
    const importIfVisible = async () => {
      const ifvisible = await import("ifvisible.js");
      setIfVisible(ifvisible);
    };

    importIfVisible();
  }, []);
};

export default useImportIfVisible;
